import {PriceSource, PriceSummary} from "./PriceSource";
import {Observable} from "rxjs";

export class StaticPriceSource implements PriceSource {

    private readonly source: Observable<PriceSummary>;

    private constructor(price: PriceSummary) {
        this.source = Observable.of(price);
    }

    public updates(): Observable<PriceSummary> {
        return this.source;
    }

    public static from(code: string, price: number, asAt: string) {
        const summary = {code, price, asAt};
        return new StaticPriceSource(summary);
    }
}
